module.exports = __webpack_public_path__ + "static/img/icon.ba39dd06.png";